/**
 * NOT CHECKED
 */
import React, { ReactNode } from 'react';

import cn from 'class-names';

import Loader from '@uikit/old/Loader/Loader';

import './Checkbox.scss';

type CheckboxPropsType = {
  children?: ReactNode;
  onChange: any;
  value: boolean;
  unbordered?: boolean;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  isCustomYesNo?: boolean;
  size?: 's' | 'm' | 'l' | 'xl';
  /** Rendered as data-testid on the label root (for ui-automation-tests) */
  testId?: string;
};

const Checkbox = ({
  isCustomYesNo,
  children = null,
  onChange = () => null,
  value = false,
  unbordered = false,
  className,
  disabled,
  isLoading,
  size,
  testId,
}: CheckboxPropsType): JSX.Element => {
  const checkmarkClass = cn('checkbox__checkmark', {
    'checkbox__checkmark--unbordered': unbordered,
  });

  const cnLabel = cn('checkbox', {
    'checkbox--disabled': disabled,
    'custom-yes-no': isCustomYesNo,
    [className]: className?.length > 0,
    [`checkbox--size-${size}`]: size,
  });

  if (isLoading) {
    return (
      <label className={cnLabel} data-testid={testId}>
        <Loader
          isLoading
          backgroundColor="#000"
          style={{ width: '15px', height: '15px', background: '#ffffff' }}
        />
      </label>
    );
  }

  return (
    <label className={cnLabel} onClick={(e) => e.stopPropagation()} data-testid={testId}>
      <input
        onChange={onChange}
        disabled={disabled}
        className="checkbox__field"
        type="checkbox"
        checked={value}
      />
      {children}
      <span className={checkmarkClass} />
    </label>
  );
};

export default Checkbox;
